module.exports = __webpack_public_path__ + "static/img/06.6b8e9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/06.png
// module id = SHTs
// module chunks = 64